import { getSiteConfig } from '../../siteConfig';

export const getImageUrl = (url) => {
  if (url) {
    const filename =
      url.indexOf('a.storyblok.com') === -1
        ? url.replace('www.', 'www2.')
        : url;
    return filename;
  }

  //return `/.netlify/image?url=${filename}`;
};

export const getQbankImageId = (url) => {
  return url?.replace(/^(.*?)published\//g, '').replace(/[^0-9]/g, '');
};

const screenWidths = {
  '640px': {
    'w-full': '640x640',
    'w-3/4': '640x640',
    'w-2/3': '640x640',
    'w-1/2': '640x640',
    'w-1/3': '640x640',
    'w-1/4': '640x640',
    auto: '640x640',
  },
  '768px': {
    'w-full': '768x768',
    'w-3/4': '768x768',
    'w-2/3': '768x768',
    'w-1/2': '768x768',
    'w-1/3': '768x768',
    'w-1/4': '768x768',
    auto: '768x768',
  },
  '1024px': {
    'w-full': '1024x768',
    'w-3/4': '1024x768',
    'w-2/3': '1024x768',
    'w-1/2': '640x640',
    'w-1/3': '640x640',
    'w-1/4': '640x640',
    auto: '1024x768',
  },
  '1440px': {
    'w-full': '1440x1024',
    'w-3/4': '1440x1024',
    'w-2/3': '1440x1024',
    'w-1/2': '720x720',
    'w-1/3': '512x512',
    'w-1/4': '512x512',
    auto: '1440x1024',
  },
};

const screenWidthsNoHeight = {
  '640px': {
    'w-full': '640x0',
    'w-3/4': '640x0',
    'w-2/3': '640x0',
    'w-1/2': '640x0',
    'w-1/3': '640x0',
    'w-1/4': '640x0',
    auto: '640x0',
  },
  '768px': {
    'w-full': '768x0',
    'w-3/4': '768x0',
    'w-2/3': '768x0',
    'w-1/2': '768x0',
    'w-1/3': '768x0',
    'w-1/4': '768x0',
    auto: '768x0',
  },
  '1024px': {
    'w-full': '1024x0',
    'w-3/4': '1024x0',
    'w-2/3': '1024x0',
    'w-1/2': '640x0',
    'w-1/3': '640x0',
    'w-1/4': '640x0',
    auto: '1024x0',
  },
  '1440px': {
    'w-full': '1440x0',
    'w-3/4': '1440x0',
    'w-2/3': '1440x0',
    'w-1/2': '768x0',
    'w-1/3': '512x0',
    'w-1/4': '512x0',
    auto: '1440x0',
  },
};

const screenWidthsAspect43 = {
  '640px': {
    'w-full': '640x480',
    'w-3/4': '640x480',
    'w-2/3': '640x480',
    'w-1/2': '640x480',
    'w-1/3': '640x480',
    'w-1/4': '640x480',
    auto: '640x480',
  },
  '768px': {
    'w-full': '768x567',
    'w-3/4': '768x567',
    'w-2/3': '768x567',
    'w-1/2': '768x567',
    'w-1/3': '768x567',
    'w-1/4': '768x567',
    auto: '768x567',
  },
  '1024px': {
    'w-full': '1024x768',
    'w-3/4': '1024x768',
    'w-2/3': '1024x768',
    'w-1/2': '640x480',
    'w-1/3': '640x480',
    'w-1/4': '640x480',
    auto: '1024x768',
  },
  '1440px': {
    'w-full': '1440x1080',
    'w-3/4': '1440x1080',
    'w-2/3': '1440x1080',
    'w-1/2': '768x567',
    'w-1/3': '512x384',
    'w-1/4': '512x384',
    auto: '1440x1080',
  },
};

export const getResponsiveImageUrl = ({
  filename,
  imageId,
  parentWidth = 'w-full',
  screenWidth,
  forceAspect,
  inSlider,
}) => {
  let imageSize = screenWidthsNoHeight[screenWidth][parentWidth];

  if (forceAspect === true || inSlider) {
    imageSize = screenWidths[screenWidth][parentWidth];
  }

  if (forceAspect === 'aspect-4/3') {
    imageSize = screenWidthsAspect43[screenWidth][parentWidth];
  }

  //console.log(filename);

  if (imageId) {
    const wh = imageSize.split('x');

    const url = `${
      getSiteConfig().siteUrl
    }/.netlify/images?url=http://alp-web-resources.s3-website-eu-west-1.amazonaws.com/qbank/${imageId}.jpg&w=${
      wh[0]
    }&h=${wh[1]}&${forceAspect ? 'fit=cover' : ''}`;
    /*const url = `${getSiteConfig().siteUrl}/img/${imageId}.jpg&w=${wh[0]}&h=${
      wh[1]
    }&${forceAspect ? 'fit=cover' : ''}`;*/

    return url;
  } else if (filename) {
    const smartResize = filename.indexOf('a.storyblok.com') > -1;

    if (smartResize) {
      const url = `${filename}${smartResize ? '/m/' : ''}${imageSize}`;
      return url;
    } else {
      return filename;
    }
  }
};
